import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';

export type EventqButtonVariant =
  'primary-outline' | 'primary-solid' | 'ghost-okta' | 'tertiary' | 'danger';
export type EventqButtonSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'eventq-button',
  imports: [MatButton, MatIcon, PrefixUrlPipe],
  templateUrl: './button.html',
  styleUrl: './button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.eventq-button-host--lg]': "size() === 'lg'",
    '[attr.disabled]': 'disabled() ? "" : null',
  },
})
export class EventqButton {
  private readonly host = inject(ElementRef<HTMLElement>);

  /** Host element for anchored overlays such as dialog popovers. */
  readonly hostElement = this.host.nativeElement;

  readonly label = input.required<string>();
  readonly variant = input<EventqButtonVariant>('primary-outline');
  readonly size = input<EventqButtonSize>('sm');
  readonly disabled = input(false);
  readonly active = input(false);
  readonly type = input<'button' | 'submit'>('button');
  readonly iconSrc = input<string | null>(null);
  readonly matIcon = input<string | null>(null);
  readonly badgeCount = input<number | null>(null);
  readonly helpText = input<string | null>(null);

  readonly pressed = output<void>();

  readonly showHelp = signal(false);
  private helpTimer: ReturnType<typeof setTimeout> | null = null;

  onMouseEnter(): void {
    if (!this.helpText()) {
      return;
    }
    this.helpTimer = setTimeout(() => this.showHelp.set(true), 500);
  }

  onMouseLeave(): void {
    if (this.helpTimer) {
      clearTimeout(this.helpTimer);
      this.helpTimer = null;
    }
    this.showHelp.set(false);
  }
}
